export const goToMailCommand = "HTb";
export const goToCalendarCommand = "ITb";
export const goToPeopleCommand = "JTb";
export const goToTasksCommand = "KTb";
export const goToToDoCommand = "LTb";
export const goToDevToolsCommand = "MTb";
export const goToEdgeTracingToolsCommand = "NTb";
export default {goToMailCommand,goToCalendarCommand,goToPeopleCommand,goToTasksCommand,goToToDoCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand};